export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-remove-cf160c6b982cbb847f5581210e486dc2.svg";